Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-wishlist'),
        wrapper;

    var model = null;

    if ($wrapper.length < 1)
        return;

    wrapper = $wrapper.get(0);

    wrapper.loading = function loading(loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        };
    };

    wrapper.extendModel = function () {
        if (window.B2BModel === undefined) return;
        _.extend(model, window.B2BModel);
    };

    wrapper.update = function () {
        wrapper.loading(true);

        var html = Vendd.Handlebars.parse("wishlist", model);
        wrapper.bind(html);

        wrapper.loading(false);
    };

    wrapper.bind = function bind(html) {
        $wrapper.html(html);
    };

    $wrapper.on('click', '.js-remove', function (e) {
        var $this = $(this),
            $item = $this.closest('.wishlist-item');

        var id = $item.data('identifier');

        wrapper.loading(true);

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Wishlist.Messages.Remove(id));
    });

    $wrapper.on('click', '.js-remove-all', function (e) {
        wrapper.loading(true);

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Wishlist.Messages.Clear());
    });

    $wrapper.on('click', '.js-add-to-cart', function (e) {
        var $this = $(this),
            $item = $this.closest('.wishlist-item');

        var id = $item.data('identifier'),
            productId = $item.data('productid'),
            skuId = $item.data('variantid'),
            path = $item.data('path');

        wrapper.loading(true);

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Wishlist.Messages.MoveToCart(id, productId, skuId, path));
    });

    $wrapper.on('click', '.js-qty-change', function (e) {
        var $this, $item, itemId, $spinner, $input, val, min, max, step;

        $this = $(this);

        if ($this.hasClass('disabled')) return;

        $item = $this.closest('.wishlist-item');
        itemId = $item.data('identifier');
        $spinner = $this.parent();
        $input = $this.siblings('input[name="qty"]').eq(0);
        val = ($input.val() ? stringToNumber($input.val()) : null) || 1;
        min = ($item.attr("data-min-quantity") ? stringToNumber($item.attr("data-min-quantity")) : null) || 1;
        max = ($item.attr("data-max-quantity") ? stringToNumber($item.attr("data-max-quantity")) : null) || 100000;
        step = ($item.attr("data-quanta") ? stringToNumber($item.attr("data-quanta")) : null) || 1;


        if (isNaN(val) || isNaN(min) || isNaN(max) || isNaN(step)) {
            console.error('Error found in quantity selector\'s values');
        }

        if ($this.hasClass('js-decrement')) {

            if (min === "" && max === "" && step === "") {
                min = parseInt($spinner.data('min'));
                max = parseInt($spinner.data('max'));
                step = parseInt($spinner.data('step'));
                val = parseInt(val) - parseInt(step);
            }
            else if (Vendd.Helpers.isInteger(parseFloat(step))) {
                val = parseInt(val) - parseInt(step);
            }
            else if (parseFloat(val) > parseFloat(min) && (parseFloat(val) - parseFloat(step) >= parseFloat(min))) {
                val = parseFloat(val) - parseFloat(step);
                val = parseFloat(val).toFixed(2);
            }
            $input.val(numberToString(val));
            $this.siblings('.js-increment').removeClass('disabled');
            $this.siblings('.js-increment').removeAttr('disabled');

            if (parseFloat(val) === parseFloat(min)) {
                $this.addClass('disabled');
                $this.attr('disabled', 'disabled');
            }
        } else if ($this.hasClass('js-increment')) {

            if (min === "" && max === "" && step === "") {
                min = parseInt($spinner.data('min'));
                max = parseInt($spinner.data('max'));
                step = parseInt($spinner.data('step'));
                val = parseInt(val) + parseInt(step);
            }
            else if (Vendd.Helpers.isInteger(parseFloat(step))) {
                val = parseInt(val) + parseInt(step);
            }
            else if (parseFloat(val) < parseFloat((max == null || max === "" || max <= 0 ? 1000000 : max)) && (parseFloat(val) + parseFloat(step)) <= parseFloat((max == null || max === "" || max <= 0 ? 1000000 : max))) {
                val = parseFloat(val) + parseFloat(step);
                val = parseFloat(val).toFixed(2);
            }

            $input.val(numberToString(val));
            $this.siblings('.js-decrement').removeClass('disabled');
            $this.siblings('.js-decrement').removeAttr('disabled');

            if (parseFloat(val) === parseFloat(max)) {
                $this.addClass('disabled');
                $this.attr('disabled', 'disabled');

            }
        }

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Wishlist.Messages.UpdateItemQuantity(itemId, val));

    });

	$wrapper.on('click', '.js-add-to-wishlist', function (e) {
		var $this = $(this),
			$item = $this.closest('.wishlist-item');

	    var id = $item.data('identifier'),
	        skuId = $item.data('variantid'),
	        path = $item.data('path'),
	        qty = 1;

		if (LhApp.Context.MultipleWishlistsEnabled && $('.js-wishlist-lists', $item).length > 0) {
			var check = $('.x-wishlist-list', $item).length < 1;
			LhApp.Function.hideAllProductWishlists();
			if (check) {
				var product = { id: id, skuId: skuId, path: path, qty: qty };
				LhApp.Function.showProductWishlists($item, product);
			}
		}
	});

    Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.Changed, wrapper, function (envelope) {
        model = envelope.message.data;
        wrapper.extendModel();
        wrapper.update();
    });

    Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.Failed, wrapper, function (envelope) {
        wrapper.loading(false);
    });

    var currentUrl = window.location.href;
    var _isWishlistPage = currentUrl.toLowerCase().indexOf("/wishlist/") !== -1;

    Vendd.MessageBus.publishAsync(wrapper, new Vendd.Wishlist.Messages.GetModel(_isWishlistPage));

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Warning, wrapper, function (envelope) {
        if (envelope.message.data.success === true) {
            model.HasValidationError = true;
            model.WarningMessage = envelope.message.data.data.Messages[0];
            wrapper.extendModel();
            wrapper.update();
        }
        wrapper.loading(false);
    });

});
